import React, { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { context as RehearsalContext } from '../../context/rehearsal'

import {
  StatusContainer,
  StatusLabel,
  GroupName,
  RoleIndicator
} from '../../styled/rehearsal-status'

const RehearsalStatus = () => {
  const navigate = useNavigate()
  const { rehearsal, isOwner, isFollowing, activeRehearsals } = useContext(RehearsalContext)
  const [groupName, setGroupName] = useState('Unknown Group')

  // Use activeRehearsals to get properly populated data
  useEffect(() => {
    if (rehearsal && activeRehearsals.length > 0) {
      // Find the matching rehearsal in activeRehearsals which has populated data
      const populatedRehearsal = activeRehearsals.find(r => r._id === rehearsal._id)

      if (populatedRehearsal) {
        const name = populatedRehearsal.group?.title || populatedRehearsal.group?.name || 'Unknown Group'
        setGroupName(name)
      } else {
        // Fallback to rehearsal object
        const name = rehearsal.group?.title || rehearsal.group?.name || 'Unknown Group'
        setGroupName(name)
      }
    } else if (rehearsal) {
      // Just rehearsal, no activeRehearsals
      const name = rehearsal.group?.title || rehearsal.group?.name || 'Unknown Group'
      setGroupName(name)
    }
  }, [rehearsal, activeRehearsals])

  // Don't display status if not in a rehearsal or if user is neither owner nor follower
  if (!rehearsal || !rehearsal.active || (!isOwner && !isFollowing)) {
    return null
  }

  const roleText = isOwner ? 'Owner' : 'Following'

  const handleClick = () => {
    // Try to get group ID from activeRehearsals first, then fallback to rehearsal
    const populatedRehearsal = activeRehearsals.find(r => r._id === rehearsal._id)
    const groupId = populatedRehearsal?.group?._id || rehearsal.group?._id || rehearsal.group

    if (groupId) {
      navigate(`/groups/${groupId}`)
    }
  }

  return (
    <StatusContainer onClick={handleClick}>
      <StatusLabel>Rehearsing:</StatusLabel>
      <GroupName>{groupName}</GroupName>
      <RoleIndicator>({roleText})</RoleIndicator>
    </StatusContainer>
  )
}

export default RehearsalStatus
